module.exports = __webpack_public_path__ + "files/590d0fc5cbed375918c094d312b75e0c.png";